import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Chip, useMediaQuery, useTheme } from '@material-ui/core';
import Typography from '@/features/markets/components/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.extralight,
    color: theme.palette.primary.main,
    minHeight: '35px',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(0.3),
      paddingRight: theme.spacing(0.3),
    },
  },
  hover: {
    '&&:hover': {
      backgroundColor: theme.palette.primary.superlight,
    },
    '&&:focus': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  hoverActive: {
    '&&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '&&:focus': {
      backgroundColor: theme.palette.primary.main,
    },
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

interface Props {
  isActive: boolean;
  onClick: () => void;
  label: string;
  avatar?: React.ReactElement;
}

const defaultProps = {};

const ChipButton = ({
  isActive, onClick, label, avatar,
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Chip
      clickable
      onClick={onClick}
      label={(
        <Typography
          color="primary"
          variant={sm ? 'small2medium' : 'secondary2medium'}
          style={
            isActive
              ? {
                color: theme.palette.greyScale.superlight,
                fontWeight: 600,
              }
              : { color: theme.palette.primary.main }
          }
        >
          {label}
        </Typography>
      )}
      avatar={avatar}
      className={classes.root}
      classes={
        !isActive ? { root: classes.hover } : { root: classes.hoverActive }
      }
    />
  );
};

ChipButton.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default ChipButton;
